export default __webpack_public_path__ + "/dist/images/mission-img.9438cd89512e548244cd1015c6078615.png";